const COUNTRY_TO_STATE_MAP = {
  US: {
    '': '',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    FL: 'Florida',
    FM: 'Federated States Of Micronesia',
    WY: 'Wyoming',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NY: 'New York',
    RI: 'Rhode Island',
    NV: 'Nevada',
    GU: 'Guam',
    CO: 'Colorado',
    CA: 'California',
    GA: 'Georgia',
    CT: 'Connecticut',
    OK: 'Oklahoma',
    OH: 'Ohio',
    KS: 'Kansas',
    SC: 'South Carolina',
    KY: 'Kentucky',
    OR: 'Oregon',
    SD: 'South Dakota',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    HI: 'Hawaii',
    PR: 'Puerto Rico',
    PW: 'Palau',
    TX: 'Texas',
    LA: 'Louisiana',
    TN: 'Tennessee',
    PA: 'Pennsylvania',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    AK: 'Alaska',
    AL: 'Alabama',
    AS: 'American Samoa',
    AR: 'Arkansas',
    VT: 'Vermont',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    AZ: 'Arizona',
    ID: 'Idaho',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    UT: 'Utah',
    MO: 'Missouri',
    MN: 'Minnesota',
    MI: 'Michigan',
    MH: 'Marshall Islands',
    MT: 'Montana',
    MP: 'Northern Mariana Islands',
    MS: 'Mississippi',
  },
  AU: {
    '': '',
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia',
  },
} as const;

export default COUNTRY_TO_STATE_MAP;
